export default "__VITE_ASSET__CVtzHTK2__"